<div class="drawer-back" (click)="onBackdropClick($event)" data-testid="account-drawer">
  <div class="drawer">
    <div class="drawer-head">
      <span class="acct-name"><span class="av">{{ initials }}</span></span>
      <div class="drawer-head__info">
        <h3>{{ account.name }}</h3>
        <small>
          {{ account.email }}
          <ng-container *ngIf="account.phone"> · ({{ account.phone.slice(0, 2) }}) {{ account.phone.slice(2, 7) }}-{{ account.phone.slice(7) }}</ng-container>
        </small>
        <div class="drawer-head__badges">
          <span class="type-badge" *ngIf="account.balance_kind" [class.type-badge--credits]="account.balance_kind === 'credits'">
            <i class="fa" [ngClass]="account.balance_kind === 'credits' ? 'fa-layer-group' : 'fa-money'"></i>
            {{ account.balance_kind === 'credits' ? 'Créditos' : 'Carteira' }}
          </span>
          <span class="status-pill status-pill--sm" [class.status-pill--ok]="account.active" [class.status-pill--danger]="!account.active">
            {{ account.active ? 'Ativa' : 'Inativa' }}
          </span>
        </div>
      </div>
      <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm close" aria-label="Fechar" (click)="close()" data-testid="btn-close-drawer">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="drawer-body">
      <app-account-balance [source]="account" mode="block"></app-account-balance>
      <p class="field-hint" *ngIf="account.balance_kind">
        {{
          account.balance_kind === 'wallet'
            ? 'Conta migrada para a carteira: SMS e ligação saem do saldo em R$; os números "≈" são quantos envios cabem hoje pelo preço desta conta.'
            : 'Conta com pacote: SMS e ligação saem dos créditos; WhatsApp e IA saem da carteira em R$.'
        }}
      </p>
    </div>

    <div class="drawer-foot">
      <a *ngIf="account.phone" class="sf-btn sf-btn--ghost" href="https://wa.me/+55{{ account.phone }}" target="_blank">
        <i class="fa fa-whatsapp"></i> WhatsApp
      </a>
      <button type="button" class="sf-btn sf-btn--ghost" (click)="copyEmail()">
        <i class="fa fa-copy"></i> Copiar e-mail
      </button>
      <a *ngIf="canSeeStatistics" class="sf-btn sf-btn--secondary" [routerLink]="['/partner/statistics', account.id]">
        <i class="fa fa-bar-chart"></i> Estatísticas
      </a>
      <button *ngIf="canSimulate" type="button" class="sf-btn sf-btn--primary" (click)="simulate.emit(account)">
        <i class="fa fa-external-link"></i> Acessar conta
      </button>
    </div>
  </div>
</div>
